import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useState } from "react";
import { align_center } from "../Styles/VMStyles";
import MUITypography from "./MUITypography";

function AddPopUP(props) {
    const { isDisplay,renderBody,title,renderActionButton} = props
    const [openDialog,setOpenDialog]= useState(isDisplay)
  return (
    <Dialog 
    open={openDialog} 
    onClose={() => setOpenDialog(false)}
    fullWidth  
    // maxWidth="md"
    sx={{ "& .MuiDialog-paper": { p: 2 } }} 
     >
      <DialogTitle>
        <MUITypography sx={align_center} >{title}</MUITypography>
      </DialogTitle>
      
      <DialogContent>
       {renderBody}
      </DialogContent>

      <DialogActions >
        {renderActionButton}
      </DialogActions>
    </Dialog>
  );
}

export default AddPopUP;
